import styled, { css } from 'styled-components/macro';

import { AlignItemsType, JustifyContentType } from 'common/types/flex';

export const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 12px;
  padding-left: 12px;
`;

export const Row = styled.div<{
  alignItems?: AlignItemsType;
  margin?: string;
  justifyContent?: JustifyContentType;
  backgroundColor?: string;
  padding?: string;
  border?: string;
  borderRadius?: string;
  flexFlow?: string;
}>`
  display: flex;
  flex-wrap: wrap;

  ${({ margin }) =>
    margin
      ? ` margin: ${margin}; `
      : `
      margin-right: -12px;
      margin-left: -12px;
  `}

  ${({ backgroundColor }) => backgroundColor && ` background-color: ${backgroundColor};`}
  ${({ padding }) => padding && ` padding: ${padding};`}

  ${({ border }) => border && ` border: ${border};`}
  ${({ borderRadius }) => borderRadius && ` border-radius: ${borderRadius};`}

  ${({ flexFlow }) => flexFlow && ` flex-flow: ${flexFlow};`}


  ${({ alignItems }) =>
    alignItems &&
    css`
      align-items: ${alignItems};
    `}

  ${({ justifyContent }) => justifyContent && ` justify-content: ${justifyContent}; `}

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

export const Col = styled.div<{
  columnWidth?: number;
  center?: boolean;
  display?: string;
  padding?: string;
}>`
  position: relative;

  flex: 1 0 0;

  width: 100%;

  ${({ padding }) =>
    padding
      ? ` padding: ${padding}; `
      : `
      padding-right: 12px;
      padding-left: 12px;
`}

  ${({ columnWidth }) => generateColumns(columnWidth)}
  ${({ center }) => center && `align-self:center`}
  ${({ display }) =>
    display &&
    `
      display: ${display};
      align-items: center;
    `}
`;

const generateColumns = (columnWidth?: number) => {
  switch (columnWidth) {
    case 10:
      return `flex: 0 0 100%;`;
    case 8:
      return `flex: 0 0 67%; 
        @media (max-width: 768px) {
          flex: 1 0 0;
        }`;
    case 6:
      return `flex: 0 0 50%; 
        @media (max-width: 768px) {
          flex: 1 0 0;
        }`;
    case 4:
      return `flex: 0 0 33%;
        @media (max-width: 992px) {
          flex: 0 0 50%;
        }
        @media (max-width: 768px) {
          flex: 0 0 100%;
        }`;
    case 3:
      return `flex: 0 0 25%;
            @media (max-width: 992px) {
              flex: 0 0 50%;
            }
            @media (max-width: 568px) {
              flex: 0 0 50%;
            }
            @media (max-width: 768px) {
              flex: 0 0 100%;
            }`;
    default:
      return `flex: 1 0 0;
        @media (max-width: 768px) {
          flex: 0 0 100%;
        }`;
  }
};
